/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
// eslint-disable-next-line no-restricted-imports
import { BTabs } from 'bootstrap-vue/esm/components/tabs';
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
const optional = p.ofType().optional;
export default tsx.componentFactoryOf().create({
    name: 'cg-tabs',
    functional: true,
    props: {
        activeNavItemClass: optional,
        activeTabClass: optional,
        align: optional,
        card: optional,
        contentClass: optional,
        end: optional,
        fill: optional,
        id: optional,
        justified: optional,
        lazy: optional,
        navClass: optional,
        navWrapperClass: optional,
        noFade: optional,
        noKeyNav: optional,
        noNavStyle: optional,
        pills: optional,
        small: optional,
        tag: optional,
        value: optional,
        vertical: optional,
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(h, ctx) {
        return h(BTabs, {
            props: ctx.props,
            attrs: ctx.data.attrs,
            class: [ctx.data.class, ctx.data.staticClass],
            style: [ctx.data.style, ctx.data.staticStyle],
            scopedSlots: ctx.scopedSlots,
            on: ctx.listeners,
        }, ctx.children);
    },
});
